// React
import React from 'react';

// Packages
import cc from 'classcat';

// Utilities
import { useLabels, useActivityTagging, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';
import TagsAlt from 'components/tagsAlt';

const ActivityDataCard = ({
    item,
    theme,
    children,
    methodsFieldName = null,
    tagTypes,
    showTags,
    showDetails,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, label, getValueLabel } = useLabels();
    const format = useFormat();

    const tagging = useActivityTagging({
        types: tagTypes,
    });

    // ///////////////////
    // DATA
    // ///////////////////

    const tags = tagging.activity.getTagsFromFieldValue(item);

    const {
        Choice,
        Things_To_Do__c,
        Things_To_Do_Description__c,
        Dates,
    } = item;

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <div
            className={cc([
                'flex flex-col p-16 mb-24 space-y-12 border rounded-8',
                {
                    'border-teal-20': theme === 'teal',
                    'border-blue-20': theme === 'blue',
                },
            ])}>
            {/* Choice */}
            <Card.CardContentSection
                {...{
                    theme,
                    title: object.label(
                        'Initiative_Activity__c.Activity_Type__c'
                    ),
                }}>
                <p>
                    {getValueLabel(
                        'Initiative_Activity__c.Activity_Type__c',
                        Choice?.Name
                    )}
                </p>
            </Card.CardContentSection>

            {/* Method */}
            {methodsFieldName && item[methodsFieldName] && (
                <Card.CardContentSection
                    {...{
                        theme,
                        title: object.label(
                            `Initiative_Activity__c.${methodsFieldName}`
                        ),
                    }}>
                    <p>
                        {getValueLabel(
                            `Initiative_Activity__c.${methodsFieldName}`,
                            item[methodsFieldName]
                        )}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            {showDetails && (
                <>
                    {/* Name */}
                    <Card.CardContentSection
                        {...{
                            theme,
                            title: object.label(
                                'Initiative_Activity__c.Things_To_Do__c'
                            ),
                        }}>
                        <p>{Things_To_Do__c}</p>
                    </Card.CardContentSection>

                    {/* Description */}
                    {Things_To_Do_Description__c && (
                        <Card.CardContentSection
                            {...{
                                theme,
                            }}>
                            <p>{Things_To_Do_Description__c}</p>
                        </Card.CardContentSection>
                    )}

                    {/* Start date / End date  */}
                    {Dates?.from && (
                        <Card.CardContentSection
                            {...{
                                theme,
                            }}>
                            <p>
                                {format.date(Dates?.from)}
                                {Dates?.to
                                    ? ` - ${format.date(Dates?.to)}`
                                    : ''}
                            </p>
                        </Card.CardContentSection>
                    )}

                    {/* Other details */}
                    {children}
                </>
            )}

            {/* Tags */}
            {showDetails && showTags && tags?.length > 0 && (
                <Card.CardContentSection
                    {...{
                        theme,
                        title: label('DetailsTagsActivities'),
                    }}>
                    <TagsAlt
                        {...{
                            theme,
                            tags,
                            className: 'mt-4',
                        }}
                    />
                </Card.CardContentSection>
            )}
        </div>
    );
};

export default ActivityDataCard;
